// src/api/modules/BoxApi.js
import Methods from "../methods";

const searchBoxes = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/box/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const getBoxById = (context, id) => {
  const url = `api/box/id/${id}`;
  return Methods.doGet(context, url);
};

const generateCode = (context) => {
  const url = 'api/box/generate'
  return Methods.doGet(context, url)
}

const checkCodeBox = (context, payload) => {
  const url = `api/box/${payload.code}/check`
  return Methods.doGet(context, url, null)
}

const getBoxByCode = (context, payload) => {
  const url = `api/box/${payload.code}`
  return Methods.doGet(context, url, null)
}

const getAllBoxesByLocation = (context, payload) => {
  const url = `api/box/specificLocation?${payload}`
  return Methods.doPost(context, url, null)
}

const getAllBoxesByLocationEmpty = (context, payload) => {
  const url = `api/box/specificLocation?${payload.params}`
  return Methods.doPostDonwload(context, url, {extExport: payload.typeExport}, `reporte-registro-cajas-vacias`, null)
}

const getAllBoxesByLocationReport = (context, payload) => {
  const url = `api/box/location/report`
  return Methods.doPostDonwload2(context, url, {data: payload.data, extExport: "pdf"}, `reporte-registro-cajas`, null)
}

const searchAvailableBoxes = (context, payload) => {
  const url = `api/box/available`;
  return Methods.doPost(context, url, payload, null);
};

const saveBoxesByLocationData = (context, payload) => {
  const url = `api/box/location?${payload.params}`
  return Methods.doPost(context, url, payload.data, null)
}

const saveBox = (context, payload) => {
  const url = `api/box`
  return Methods.doPost(context, url, payload.box, null)
}

const editBox = (context, payload) => {
  const url = `api/box`
  return Methods.doPut(context, url, payload.box, null)
}

const bulkUploadBoxes = (context, payload) => {
  const { file, data } = payload;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", new Blob([JSON.stringify(data)], { type: "application/json" }));

  const url = `api/box/bulk-upload`;
  return Methods.doPostMultipart(context, url, formData);
};

const loadLowOfBox = (context, payload) => {
  const url = `api/box/lowOfBox/${payload.idClient}?page=${payload.page}&size=${payload.size}`;
  return Methods.doGet(context, url, null);
};

const uptLowOfBox = (context, payload) => {
  const url = `api/box/uptLowOfBox/`
  return Methods.doPut(context, url, payload.lowBox, null)
}

const downloadLowBoxReport = (context, payload) => {
  const url = `api/box/lowBoxReport/${payload.id}/excel`;
  return Methods.doPostDonwload(
    context,
    url,
    {extExport: 'xlsx'},
    payload.fileName,
    null
  );
}

const loadLowBoxReport = (context, payload) => {
  const url = `api/box/loadLowOfBox/${payload.idClient}?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}&status=${payload.status}`;
  return Methods.doGet(context, url, null);
};

const lowBoxReportExportExcelDetail = (context, payload) => {
  const url = `api/box/client/${payload.idClient}/excel-detail?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}&status=${payload.status}`;
  return Methods.doPostDonwload(
    context,
    url,
    {extExport: 'xlsx'},
    `reporte-baja-cajas-detallado-${payload.nameClient}`,
    null
  )
}

const lowBoxReportExportExcel = (context, payload) => {
  const url = `api/box/client/${payload.idClient}/excel?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}&status=${payload.status}`;
  return Methods.doPostDonwload(
    context,
    url,
    {extExport: 'xlsx'},
    `reporte-baja-cajas-${payload.nameClient}`,
    null
  );
};

const lowBoxReportExportPDF = (context, payload) => {
  const url = `api/box/client/${payload.idClient}/pdf?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}&status=${payload.status}`;
  return Methods.doPostDonwload(
    context,
    url,
    {extExport: 'pdf'},
    `reporte-baja-cajas-${payload.nameClient}`,
    null
  );
};

export default {
  searchBoxes,
  getBoxById,
  generateCode,
  checkCodeBox,
  saveBox,
  editBox,
  bulkUploadBoxes,
  getBoxByCode,
  getAllBoxesByLocation,
  getAllBoxesByLocationReport,
  searchAvailableBoxes,
  saveBoxesByLocationData,
  getAllBoxesByLocationEmpty,
  loadLowOfBox,
  uptLowOfBox,
  downloadLowBoxReport,
  loadLowBoxReport,
  lowBoxReportExportExcel,
  lowBoxReportExportExcelDetail,
  lowBoxReportExportPDF,
};






// WEBPACK FOOTER //
// ./src/api/modules/BoxApi.js